import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function TransactionFailed(props) {
    return (React.createElement(Svg, { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Rect, { width: 40, height: 40, rx: 20, fill: "#FF7B7E", fillOpacity: 0.12 }),
        React.createElement(Path, { d: "M16.25 23.708l8.145-8.146a.6.6 0 01.438-.187.6.6 0 01.438.187.611.611 0 01.187.448.611.611 0 01-.188.448l-8.145 8.125h7.25a.607.607 0 01.625.625.607.607 0 01-.625.625h-8.75a.607.607 0 01-.625-.625v-8.75a.607.607 0 01.625-.625.607.607 0 01.625.625v7.25z", fill: "#FF7B7E" })));
}
export default TransactionFailed;
